$(document).ready(() => {
  // global stuff
  $('.block-content  .slide-links .slide-link').slide(
    {
      selectorForSlideLinks: '.block-content .slide-links',
      selectorForSlides: '.block-content .slides'
    }
  );
});
